import { useEffect, useState } from 'react';

type ScreenReaderAnnouncementProps = {
  message: string | null;
  priority?: 'polite' | 'assertive';
};

export default function ScreenReaderAnnouncement({
  message,
  priority = 'polite',
}: ScreenReaderAnnouncementProps) {
  const [announcement, setAnnouncement] = useState<string | null>(null);

  useEffect(() => {
    if (message) {
      // Clear previous announcement to ensure new announcement is read
      setAnnouncement(null);

      // Small delay to ensure screen readers detect the change
      const timer = setTimeout(() => {
        setAnnouncement(message);
      }, 50);

      return () => clearTimeout(timer);
    }
  }, [message]);

  // Always render the live region, but only populate it when we have a message
  // This ensures the region is always in the DOM and ready to receive announcements
  return (
    <div
      aria-live={priority}
      aria-atomic="true"
      className="sr-only"
      role="status"
      aria-relevant="additions text"
    >
      {announcement}
    </div>
  );
}
